// extracted by mini-css-extract-plugin
module.exports = {"image":"email_image__1Y1ZD"};